import './lib/polyfill';

import './lib/import-jquery';

require('bootstrap');   // mit Bootstrap 4 reicht import 'bootstrap'
//import 'bootstrap/js/popover'; // You can manually load Bootstrap's jQuery plugins individually by loading the /js/*.js files

require('javascript-detect-element-resize/jquery.resize');

// EPSG-Definitions
import './js/proj4/epsg.js';

//import './js/namespace.js';  // include erfolgt in Template
import './js/abstract.js';
import './js/assert.js';
import './js/observable.js';
import './js/wrappable.js';
import './js/log.js';
import './js/extent.js';
import './js/url.js';
import './js/map/format.js';

import './js/error/gc-error.js';
import './js/error/assertion-error.js';
import './js/error/out-of-max-extent-error.js';
import './js/error/unsupported-error.js';
import './js/error/projection-error.js';

import './js/util/util.js';
import './js/util/request-manager.js';
import './js/util/tree-node.js';
import './js/util/form.js';
import './js/util/form-renderer.js';
import './js/util/storage.js';

import './js/factory/factory.js';
import './js/factory/ol-factory.js';
import './js/factory/service-factory.js';
import './js/factory/style-factory.js';

import './js/service/abstract-service.js';
import './js/service/query-feature-service.js';
import './js/service/html-popup-service.js';
import './js/service/transaction-feature-service.js';
import './js/service/feature/query/abstract-query-feature.js';
import './js/service/feature/query/query-fachdb-feature.js';
import './js/service/feature/query/query-simple-feature.js';
import './js/service/feature/transaction/abstract-transaction-feature.js';
import './js/service/feature/transaction/transaction-fachdb-feature.js';
import './js/service/feature/transaction/transaction-simple-feature.js';

import './js/ol/util.js';

import './js/geometry/geometry.js';
import './js/geometry/point.js';
import './js/geometry/linestring.js';
import './js/geometry/linearring.js';
import './js/geometry/polygon.js';
import './js/geometry/circle.js';
import './js/geometry/multipoint.js';
import './js/geometry/multilinestring.js';
import './js/geometry/multipolygon.js';
import './js/geometry/geometrycollection.js';
import './js/geometry/geometryprocessor.js';
import './js/ol/geometry/geometry.js';
import './js/ol/geometry/point.js';
import './js/ol/geometry/linestring.js';
import './js/ol/geometry/linearring.js';
import './js/ol/geometry/polygon.js';
import './js/ol/geometry/circle.js';
import './js/ol/geometry/multipoint.js';
import './js/ol/geometry/multilinestring.js';
import './js/ol/geometry/multipolygon.js';
import './js/ol/geometry/geometrycollection.js';
import './js/ol/geometry/geometryprocessor.js';
import './js/ol/geometry/geometryfactory.js';

import './js/feature/feature.js';
import './js/ol/feature/feature.js';

import './js/format/format.js';
import './js/format/wmts-capabilities.js';
import './js/format/wmts-capabilities-layer.js';
import './js/ol/format/format.js';
import './js/ol/format/format-wmts-capabilities.js';

import './js/style/abstract-style.js';
import './js/style/circle.js';
import './js/style/color.js';
import './js/style/fill.js';
import './js/style/stroke.js';
import './js/ol/style/circle.js';
import './js/ol/style/fill.js';
import './js/ol/style/stroke.js';
import './js/ol/style/style-factory.js';

import './js/map/namespace.js';
import './js/layer/abstract-layer.js';
import './js/layer/group-layer.js';
import './js/layer/layer.js';
import './js/layer/vector-layer.js';
import './js/layer/raster-layer.js';
import './js/layer/tracking-layer.js';
import './js/map/abstract-layer-factory.js';
import './js/ol/layer-factory.js';
import './js/map/abstract-wms-provider.js';
import './js/map/abstract-wfs-provider.js';
import './js/map/abstract-wmts-provider.js';
import './js/ol/wms-provider.js';
import './js/ol/wfs-provider.js';
import './js/ol/wmts-provider.js';
import './js/map/mapview.js';
import './js/map/abstract-map.js';
import './js/map/layer-tree-manager.js';
import './js/map/background-layer-manager.js';
import './js/map/background-layer-initiator.js';
import './js/ol/map.js';
import './js/ol/layer/tracking-layer.js';
import './js/map/abstract-map-draw-interaction.js';
import './js/ol/map-draw-interaction.js';
import './js/map/abstract-map-transform-interaction.js';
import './js/ol/map-transform-interaction.js';
import './js/map/abstract-map-select-interaction.js';
import './js/ol/map-select-interaction.js';
import './js/ol/source/mapcatalogue-vector.js';
import './js/ol/map-tooltip.js';

import './js/widget/widget.js';
import './js/widget/accordion.js';
import './js/widget/list.js';
import './js/widget/panel.js';
import './js/widget/dialog.js';
import './js/widget/item.js';
import './js/widget/group.js';
import './js/widget/menu.js';
import './js/widget/radio-item.js';
import './js/widget/toggle-item.js';
import './js/widget/badge.js';
import './js/widget/slider.js';
import './js/widget/popup.js';
import './js/widget/search.js';
import './js/widget/input.js';
import './js/widget/select.js';
import './js/widget/split-button.js';
import './js/widget/toggle-split-button.js';
import './js/widget/scale-selector.js';
import './js/widget/layer-selector.js';

import './js/map/control/abstract-map-control.js';
import './js/map/control/loading-indicator.js';
import './js/map/control/loading-timer.js';
import './js/map/control/scale-switcher.js';
import './js/map/control/geolocator.js';
import './js/map/control/zoom-reset.js';
import './js/map/control/rotate.js';
import './js/map/control/fullscreen.js';
import './js/map/control/attribution.js';
import './js/map/control/notification-manager.js';
import './js/map/control/session-viewport.js';
import './js/map/control/drawingarea-clear.js';
import './js/map/control/snap.js';
import './js/map/control/layer-tooltip-manager.js';
import './js/map/control/background-layer-switcher/background-layer-switcher.js';
import './js/ol/control/scale-bar.js';
import './js/ol/control/mouse-position.js';
import './js/ol/control/zoom-in-out-box.js';
import './js/ol/control/snap.js';

import './js/action/abstract-action.js';
import './js/action/toggle-fullscreen.js';
import './js/action/open-link.js';
import './js/action/serverside-action-factory.js';
import './js/action/layer/fit-extent.js';
import './js/action/layer/remove-selection.js';
import './js/action/layer/group-selection.js';
import './js/action/layer/deselect-features.js';
import './js/action/layer/new-group-layer.js';
import './js/action/layer/rename-layer.js';
import './js/action/layer/remove-all-layer.js';
import './js/action/layer/remove-layer.js';
import './js/action/layer/remove-unvisible-layer.js';
import './js/action/layer/dissolve-group.js';
import './js/action/layer/set-visibility-all-layer.js';
import './js/action/layer/toggle-selection.js';
import './js/action/layer/toggle-expansion.js';
import './js/action/layer/toggle-visibility.js';
import './js/action/layer/show-attribute-table.js';
import './js/action/layer/show-layerinfo.js';
import './js/action/layer/zoom-to-selection.js';

import './js/modules/abstract-module.js';
import './js/modules/abstract-container-modul.js';

import './js/map/control/projection-switcher.js';
import './js/ui/namespace.js';
import './js/ui/sidebar-content.js';
import './js/ui/sidebar.js';
import './js/ui/navbar.js';
import './js/ui/toolbar.js';
import './js/ui/user-interface.js';
import './js/application.js';

// Admin
import './js/modules/admin/module.js';
import './js/modules/admin/panel.js';

// ALKIS-Export
import './js/modules/alkisexport/module.js';
import './js/modules/alkisexport/panel.js';

// Digitalisierung
import './js/modules/digitize/module.js';
import './js/modules/digitize/panel-main.js';
import './js/modules/digitize/panel-save.js';
import './js/modules/digitize/panel-export.js';
import './js/modules/digitize/panel-draw.js';
import './js/modules/digitize/panel-select.js';
import './js/modules/digitize/panel-geoprocessing.js';
import './js/modules/digitize/impl.js';
import './js/modules/digitize/ol-impl.js';

// Geometrie bearbeiten
import './js/modules/editgeometry/module.js';
import './js/modules/editgeometry/panel-main.js';
import './js/modules/editgeometry/impl.js';
import './js/modules/editgeometry/ol-impl.js';

// Errorkonsole
import './js/modules/errorconsole/module.js';
import './js/modules/errorconsole/action/clear.js';
import './js/modules/errorconsole/action/dump.js';
import './js/modules/errorconsole/action/filter.js';
import './js/modules/errorconsole/action/toggle-debug.js';
import './js/modules/errorconsole/panel.js';

// FeatureInfo
import './js/modules/featureinfo/module.js';
import './js/modules/featureinfo/panel.js';
import './js/modules/featureinfo/info-dialog.js';
import './js/modules/featureinfo/widget/layer-resultlist.js';
import './js/modules/featureinfo/widget/abstract-feature-resultlist.js';
import './js/modules/featureinfo/widget/feature-resultlist-popup.js';
import './js/modules/featureinfo/widget/feature-resultlist-sidebar.js';
import './js/modules/featureinfo/provider/info-provider.js';
import './js/modules/featureinfo/provider/ol-info-provider-internal-layer.js';
import './js/modules/featureinfo/provider/ol-info-provider-wfs-layer.js';
import './js/modules/featureinfo/provider/ol-info-provider-wms-layer.js';

// Bildexport
import './js/modules/imageexport/module.js';
import './js/modules/imageexport/panel.js';

// Layer-Katalog
import './js/modules/layercatalog/module.js';
import './js/modules/layercatalog/external-panel.js';
import './js/modules/layercatalog/internal-panel.js';

// Layer-Tree
import './js/modules/layertree/module.js';
import './js/modules/layertree/panel.js';
import './js/modules/layertree/legend-panel.js';

// Locator
import './js/modules/locator/module.js';
import './js/modules/locator/abstract-geocoder.js';
import './js/modules/locator/geocoder.js';
import './js/modules/locator/nominatim.js';
import './js/modules/locator/coordinate.js';

// Measure
import './js/modules/measure/module.js';
import './js/modules/measure/impl.js';
import './js/modules/measure/ol-measure.js';
import './js/modules/measure/panel.js';

// Nav-Histor
import './js/modules/navigation/module.js';

// Overview-Map
import './js/modules/overview/module.js';
import './js/modules/overview/panel.js';
import './js/modules/overview/ol-minimap.js';

// Plot
import './js/modules/plot/module.js';
import './js/modules/plot/panel.js';
import './js/modules/plot/ol-papermask.js';

// Settings
import './js/modules/settings/module.js';
import './js/modules/settings/panel.js';

// Tools
import './js/modules/tools/module.js';

// Views
import './js/modules/views/module.js';
import './js/modules/views/panel-preview.js';
import './js/modules/views/panel-list.js';
import './js/modules/views/panel-save.js';

// 3D-Viewer
import './js/modules/link3dviewer/module.js';
